<template>
  <div class="tree-select">
    <div class="sidebar tree-select__nav">
      <div v-for="(navItem, index) in items" :key="index"
        :class="`sidebar-item tree-select__nav-item ${navIndex==index||ids.indexOf(navItem.id) > -1?'sidebar-item--select':''}`"
        @click="navclick(navItem, index)">
        <span>{{navItem.text}}</span>
        <van-icon v-show="navIndex==index||ids.indexOf(navItem.id) > -1" name="success" />
      </div>
    </div>
    <div v-for="(itemList, contentIndex) in contentList" :key="contentIndex" class="sidebar tree-select__content">
      <div v-for="(item, index) in itemList" :key="index"
        :class="`sidebar-item tree-select__content-item ${ids.indexOf(item.id) > -1?'sidebar-item--select':''}`"
        @click="itemclick (item, contentIndex)">
        <span>{{item.text}}</span>
        <van-icon v-show="ids.indexOf(item.id) > -1" name="success" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: []
    },
    activeIds: {
      type: Array,
      default: []
    },
    activeIndex: {
      type: [Number, String],
      default: 0
    },
  },
  data () {
    return {
      contentList: [],
      navIndex: 0,
      ids: []
    }
  },
  created () {
    this.navIndex = this.activeIndex
    this.ids = this.activeIds
  },
  methods: {
    navclick (data, index) {
      this.navIndex = index
      this.contentList = []
      this.ids = []
      if (data.children && data.children.length > 0) {
        this.contentList.push(data.children)
      }
      this.ids.push(data.id || '')
      this.$emit('itemclick', data)
    },
    itemclick (data, contentIndex) {
      this.ids.splice(contentIndex + 1)
      this.ids.push(data.id || '')
      if (data.children && data.children.length > 0) {
        if (contentIndex == this.contentList.length - 1) {
          this.contentList.push(data.children)
        } else {
          this.contentList.pop()
          this.contentList.push(data.children)
        }

      }
      this.$emit('itemclick', data)
    }
  }
}
</script>
<style lang="less" scoped>
.tree-select {
  display: flex;
  .sidebar {
    min-width: 40vw;
    flex: 1;
    .sidebar-item {
      padding: 14px 12px;
      font-size: 14px;
      line-height: 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        flex: 1;
      }
    }
    .sidebar-item--select {
      background-color: #fff;
      color: #3974c4;
      font-weight: 500;
    }
  }
  .tree-select__nav {
    background-color: #f7f8fa;
  }
  .tree-select__content {
    border-left: 1px solid #f4f4f4;
  }
}
</style>
